import React, { useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { Button } from 'ui-components/components/button';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { RadioCheckList } from 'ui-components/components/radio-check-list';
import { RadioCheckListItem } from 'ui-components/components/radio-check-list/radio-check-list-item';

import asModal from '../../../../../components/as-modal';
import Global from '../../../../../store/global-selectors';
import messages from '../messages';
import style from '../style.module.less';

const ExportTitle = <FormattedMessage {...messages.exportModalTitle} />;
const ExportMessage = <FormattedMessage {...messages.exportModalMessage} />;
const ExportModalExportAll = <FormattedMessage {...messages.exportModalExportAll} />;
const ExportModalExportFromWarehouse = <FormattedMessage {...messages.exportModalExportFromWarehouse} />;
const CancelButton = <FormattedMessage {...messages.cancel} />;
const ExportButton = <FormattedMessage {...messages.export} />;

const ExportFormModal = ({ onClose, onConfirm }) => {
  const warehouseLocations = useSelector(Global.selectSellerInventoryWarehouses);
  const [selectedWarehouse, setSelectedWarehouse] = useState(warehouseLocations[0] ?? '');
  const [exportAllProducts, setExportAllProducts] = useState(true);

  const toggleExportAll = useCallback(() => {
    setExportAllProducts(!exportAllProducts);
  }, [exportAllProducts]);
  const exportFile = useCallback(() => {
    onConfirm({
      exportAllProducts,
      inventoryWarehouseId: selectedWarehouse.inventoryWarehouseId,
    });
  }, [selectedWarehouse, exportAllProducts, onConfirm]);

  return (
    <Modal className={style['confirmation-modal']} size='medium'>
      <ModalHeader closeModal={onClose}>{ExportTitle}</ModalHeader>
      <ModalBody className={style['confirmation-modal-body']}>
        <h2>{ExportMessage}</h2>
        <hr />
        <RadioCheckList>
          <RadioCheckListItem className={style['select-options-radio-button']} isChecked={exportAllProducts} onChecked={toggleExportAll}>
            {ExportModalExportAll}
          </RadioCheckListItem>
          <RadioCheckListItem className={style['select-options-radio-button']} isChecked={!exportAllProducts} onChecked={toggleExportAll}>
            {ExportModalExportFromWarehouse}
          </RadioCheckListItem>
        </RadioCheckList>
        <DropdownMenu
          className={style['warehouse-dropdown-picker']}
          dropdownMenuShouldHaveWidthOfButton
          fullWidth
          title={selectedWarehouse.name}
          variant='form'
        >
          <DropdownMenuToggler>{selectedWarehouse.name}</DropdownMenuToggler>
          {warehouseLocations.map((inventoryWarehouse) => {
            const { name, inventoryWarehouseId } = inventoryWarehouse;
            return (
              <DropdownMenuItem key={`${inventoryWarehouseId}_${name}`} onClick={() => setSelectedWarehouse(inventoryWarehouse)}>
                {name}
              </DropdownMenuItem>
            );
          })}
        </DropdownMenu>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} theme='tertiary'>
          {CancelButton}
        </Button>
        <Button onClick={exportFile} theme='primary'>
          {ExportButton}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ExportFormModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default asModal(ExportFormModal);
